export const USERACCESS = "UUID";
export const LOCALLANGUAGE = "LLANG";
